define('cart_promocode_notifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cart_promocode_notifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " ";
},"useData":true}, 'extensions/WB/Posh_durastone/1.0.0/', 'extensions/WB/Posh_durastone/1.0.0/', Handlebars);
});